/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Image_Viewer_CopiedInputs */



/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Chat_Image_Viewer_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_image_viewer_copied = /** @type {((inputs?: Chat_Image_Viewer_CopiedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Image_Viewer_CopiedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kopiert")
	return /** @type {LocalizedString} */ ("Copied")
});